import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'sid',
      type: 'input',
      label: '账号ID',
      placeholder: '请输入账号ID'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人',
      options: []
    },
    {
      field: 'uname',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方',
      options: [],
      rules: { required: true, message: '请选择所属第三方', trigger: 'change' }
    }
  ]
}
